import { useQuery } from "@tanstack/react-query";
import { BlogPost, BlogPostsResponse, getBlogPostBySlug, getBlogPosts } from "../services/blog.service";

export const blogKeys = {
  all: ["blog"] as const,
  list: (page: number, pageSize: number) => [...blogKeys.all, "list", page, pageSize] as const,
  detail: (slug: string) => [...blogKeys.all, "detail", slug] as const,
};

export function useBlogPosts(page: number = 1, pageSize: number = 10) {
  return useQuery<BlogPostsResponse, Error>({
    queryKey: blogKeys.list(page, pageSize),
    queryFn: async () => {
      const response = await getBlogPosts(page, pageSize);
      if (response.error) {
        throw new Error(response.error);
      }
      return response.data as BlogPostsResponse;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}

export function useBlogPost(slug: string) {
  return useQuery<BlogPost | null, Error>({
    queryKey: blogKeys.detail(slug),
    queryFn: async () => {
      const response = await getBlogPostBySlug(slug);
      if (response.error) {
        throw new Error(response.error);
      }
      return response.data as BlogPost | null;
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
